export const trackPageView = (pageData) => {
  const name = pageData?.MetaTitle || pageData?.Name

  if (!name || typeof window === 'undefined' || !window.appInsights?.trackPageView) {
    return
  }

  window.appInsights.trackPageView({
    name,
    uri: window.location.href
  })
}
